import { useEffect, useMemo, useState } from "react";
import { masterApis } from "stores/master/masterApis";
import { masterParser } from "stores/master/masterParsers";

const EMPTY_OFFER = {
  show: false,
  title: "",
  description: "",
  badgeText: "",
  startsAt: null,
  endsAt: null,
  productInfo: {
    title: "",
    description: "",
    badgeText: "",
    highlightText: "",
    webImageUrl: null,
    mobileImageUrl: null,
  },
};

export const useProductDiscountOffer = (productCode) => {
  const [offer, setOffer] = useState(EMPTY_OFFER);
  const [loading, setLoading] = useState(Boolean(productCode));

  useEffect(() => {
    let cancelled = false;

    if (!productCode) {
      setOffer(EMPTY_OFFER);
      setLoading(false);
      return undefined;
    }

    const load = async () => {
      try {
        setLoading(true);
        const response = await masterApis.getPaymentOfferBanner({
          productCode,
        });
        if (cancelled) {
          return;
        }
        const parsed = masterParser.parsePaymentOfferBanner(response);
        setOffer(parsed || EMPTY_OFFER);
      } catch (error) {
        if (!cancelled) {
          setOffer(EMPTY_OFFER);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [productCode]);

  const isActive = useMemo(() => {
    if (!offer?.show || !offer.startsAt || !offer.endsAt) {
      return false;
    }
    const now = Date.now();
    if (now < offer.startsAt || now >= offer.endsAt) {
      return false;
    }
    const productInfo = offer.productInfo || {};
    return Boolean(
      productInfo.title ||
        productInfo.badgeText ||
        productInfo.webImageUrl ||
        productInfo.mobileImageUrl,
    );
  }, [offer]);

  return {
    offer,
    isActive,
    loading,
  };
};

export default useProductDiscountOffer;
